<div class="institution-select-wrapper flex flex-column" [ngClass]="{'open': opened, 'loading': loading}">
    <button mat-button class="" [matMenuTriggerFor]="institutionMenu" [disableRipple]="true"
            (menuOpened)="opened = true;" (menuClosed)="opened = false;" [disabled]="loading">
            <div class="btn-location-container">
                <mat-icon class="location-icon">location_on</mat-icon>
                <div class="flex-center flex-space-between location-name" *ngIf="(currentPid$ | async) as currentPid">
                    <div class="location-name__text">
                        <span>{{ 'App.General.Location' | translate }}</span>
                        <span class="location-text" *ngIf="(list$ | async) as list; else empty">{{ getCurrentPid(currentPid, list).practiceName }}</span>
                    </div>
                    <mat-icon *ngIf="!loading">expand_more</mat-icon>
                    <mat-progress-spinner *ngIf="loading" mode="indeterminate" [diameter]="24" class="margin-right-S"></mat-progress-spinner>
                </div>
            </div>
    </button>
    <mat-menu #institutionMenu="matMenu" backdropClass="institution-menu" class="institution-menu-container" xPosition="after" yPosition="below">
        <ng-container *ngFor="let item of (list$ | async)">
            <button mat-menu-item (click)="setCurrentPid(item.id)" [ngClass]="{active: (currentPid$ | async) === item.id}">
                <div class="flex-center flex-space-between institution-name">
                    <span class="text-nowrap text-trim">{{item.practiceName}}</span>
                </div>
                <div *ngIf="(defaultPid$ | async) === item.id" class="default padding-horizontal">{{'App.General.Default' | translate }}</div>
            </button>
        </ng-container>

        <button mat-flat-button color="primary" class="margin"  (click)="goToLocationManagement()">
            {{ 'App.General.Location_Management' | translate }}
        </button>
    </mat-menu>
</div>

<ng-template #empty><br></ng-template>
